export default __webpack_public_path__ + "static/obs-api-fe28dc5e0a3792807de89655e1447a85.png";